import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AccessDeniedComponent } from './core/components/access-denied/access-denied.component';
import { ErrorComponent } from './core/components/error/error.component';
import { ForgotPasswordComponent } from './core/components/forgot-password/forgot-password.component';
import { LoginComponent } from './core/components/login/login.component';
import { MaintenanceComponent } from './core/components/maintenance/maintenance.component';
import { PageNotFoundComponent } from './core/components/page-not-found/page-not-found.component';
import { AuthGuard } from './core/guards/auth/auth.guard';
import { LoginGuard } from './core/guards/login/login.guard';
import { MaintenanceGuard } from './core/guards/maintenance/maintenance.guard';

const routes: Routes = [
  {
    path: 'maintenance',
    component: MaintenanceComponent,
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
    canActivate: [MaintenanceGuard],
  },
  {
    path: 'error',
    component: ErrorComponent,
    canActivate: [MaintenanceGuard],
  },
  {
    path: 'forgot-password',
    component: ForgotPasswordComponent,
    canActivate: [MaintenanceGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [MaintenanceGuard, LoginGuard],
  },
  {
    path: 'page-not-found',
    component: PageNotFoundComponent,
    canActivate: [MaintenanceGuard],
  },
  {
    path: 'quest',
    canActivate: [MaintenanceGuard, AuthGuard],
    loadChildren: () => import('./lazy-load/lazy-load.module').then((m) => m.LazyLoadModule),
  },
  {
    path: '',
    redirectTo: 'quest',
    pathMatch: 'full',
  },
  {
    path: '**',
    redirectTo: 'page-not-found',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
